import { TimelineActionStatus } from "./enums/timeline-action-status.enum";
import { TimelineActionType } from "./timeline-action-type.model";


export interface TimelineAction {
    id: number;
    actionType: TimelineActionType;
    status: TimelineActionStatus;
    dataNdaTermId?: string;
    referenceItemId?: string;
    oldReferenceItemIds?: string[];
    actionReferenceId ?: number;
}

export const defaultTimelineAction: TimelineAction = {
    id: 0,
    actionType: TimelineActionType.BuyerExpressionOfInterest,
    status: TimelineActionStatus.InProgress,
};